import React, { useContext, useImperativeHandle, useRef } from "react";
import styles from "./index.module.scss";
import { Button, Checkbox, Input, message } from "antd";
import classNames from "classnames";
import { AnswerContent, DiscussContent } from "../../context";
import Form, { useForm } from "rc-field-form";
import useRequestFn from "../../../../../Utils/useRequestFn";
import { editPost, postReply, ReplyFormData } from "../../../../../API/discuss";
import { isTrue } from "../../../../../Utils/filter";
import { errorMessage } from "../../../../../Utils/useRequest";
import { BraftEditorProps } from "braft-editor";
import { EditProps } from "../ReplyItem";

export interface ReplyEditorInstance extends BraftEditorProps {
    touched(): boolean;
}

interface ReplyEditorProps {
    className?: string;
    content?: EditProps;
    speakToReplyUuid?: string;
    onFinish?(): void;
    setShowEditor?(v: boolean): void;
}

const ReplyEditor = React.forwardRef<ReplyEditorInstance, ReplyEditorProps>(
    (
        { className, content, setShowEditor, speakToReplyUuid, onFinish },
        ref
    ) => {
        const [form] = useForm();
        const { discussDetail, updateDiscussDetail } =
            useContext(DiscussContent);

        const {
            answerData: { topicUuid, uuid, topicType }
        } = useContext(AnswerContent);

        const containerRef = useRef<HTMLDivElement>(null);

        const [onSubmit, { loading }] = useRequestFn(
            async (data: ReplyFormData) => {
                if (!data.replyContent.trim()) {
                    message.warning("评论内容不能为空!");
                    return;
                }

                try {
                    if (content?.targetUuid) {
                        await editPost(topicUuid, content.targetUuid, {
                            anonymousSpeak: data.anonymousSpeak,
                            replyContent: data.replyContent
                        });
                    } else {
                        await postReply(topicUuid, uuid, {
                            topicType,
                            speakToReplyUuid,
                            ...data
                        });
                    }

                    message.success("评论成功!");
                    form.resetFields();
                    onFinish?.();
                    updateDiscussDetail();
                } catch (e) {
                    message.error(errorMessage(e));
                }
            }
        );

        useImperativeHandle(ref, () => ({
            touched() {
                return form.getFieldValue("replyContent");
            }
        }));

        return (
            <div
                ref={containerRef}
                className={classNames(styles.root, className)}>
                <Form form={form} className={styles.form} onFinish={onSubmit}>
                    <Form.Field
                        name="replyContent"
                        initialValue={content?.content}>
                        <Input.TextArea
                            className={styles.textarea}
                            placeholder="评论千万条, 友善第一条"
                            autoSize
                        />
                    </Form.Field>

                    <div className={styles.buttons}>
                        {isTrue(discussDetail?.canAnonymousSpeak) && (
                            <Form.Field
                                name="anonymousSpeak"
                                valuePropName="checked"
                                initialValue={false}>
                                <Checkbox>匿名发言</Checkbox>
                            </Form.Field>
                        )}

                        {setShowEditor && (
                            <Button
                                onClick={() => setShowEditor(false)}
                                loading={loading}>
                                取消
                            </Button>
                        )}
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}>
                            发布
                        </Button>
                    </div>
                </Form>
            </div>
        );
    }
);

export default ReplyEditor;
